import { AppRoutes } from './router';

export function App() {
  return <AppRoutes />;
}
